const includesProtocol = (link) => {
    try {
        const protocols = ["https", "http"];
        const existingProtocol = link.split(":")[0].toLowerCase();
        return protocols.includes(existingProtocol);
    } catch (error) {
        return false;
    }
};

const handleExternalLink = (link, mailto = false) => {
    if (link) {
        const url = mailto
            ? link
            : `${includesProtocol(link) ? "" : "//"}${link}`;
        handleLink(url);
    }
};

const handleLink = (link) => {
    if (link) {
        Object.assign(document.createElement("a"), {
            target: "_blank",
            href: link,
            rel: "noreferrer",
        }).click();
    }
};

export { handleExternalLink, includesProtocol, handleLink };
